import React from 'react';

export const LoadingSpinner = () => {
  return (
    <div className="flex justify-center items-center py-12">
      <div className="relative">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-orange-600"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <div className="h-8 w-8 bg-white rounded-full"></div>
        </div>
      </div>
    </div>
  );
};

export const LoadingTable = ({ message = "Loading data..." }: { message?: string }) => {
  return (
    <tr>
      <td colSpan={20} className="px-4 py-12 text-center">
        <div className="flex flex-col items-center justify-center space-y-4">
          <div className="relative">
            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-orange-600"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <div className="h-6 w-6 bg-white rounded-full"></div>
            </div>
          </div>
          <p className="text-gray-600 font-medium">{message}</p>
        </div>
      </td>
    </tr>
  );
};

export const LoadingCard = ({ message = "Loading..." }: { message?: string }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-8">
      <div className="flex flex-col items-center justify-center space-y-4">
        <div className="relative">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-orange-600"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <div className="h-8 w-8 bg-white rounded-full"></div>
          </div>
        </div>
        <p className="text-gray-600 font-medium text-lg">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;

